<template>
  <div>
    <fusioncharts
      v-if="tempGraph"
      width="100%"
      height="470"
      :type="type"
      :dataFormat="dataformat"
      :dataSource="dataSourceTemp"
    >
    </fusioncharts>
    <fusioncharts
      v-if="humiGraph"
      width="100%"
      height="470"
      :type="type"
      :dataFormat="dataformat"
      :dataSource="dataSourceHumi"
    >
    </fusioncharts>
    <!-- </div> -->
  </div>
</template>

<script>
import moment from "moment";
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import zoomline from "fusioncharts/fusioncharts.zoomline";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
FusionCharts.options.license({
  key: process.env.VUE_APP_FUSION_LICENSE_KEY,
  creditLabel: false,
});
Vue.use(VueFusionCharts, FusionCharts, zoomline, FusionTheme);

export default {
  name: "CombinedGroupChart",
  props: {
    devicestats: Array,
    recordtype: String,
    defaultrecordtype: Number,
    recordspan: Number,
    tempGraph: Boolean,
    humiGraph: Boolean,
    title: {
      default: "Chart",
      type: String,
    },
  },
  data() {
    return {
      type: "zoomline",
      dataformat: "json",
      dataSourceTemp: "",
      dataSourceHumi: "",
      labels: [],
      labels1: [],
      temp: [],
      maxTemp: [],
      minTemp: [],
      humidity: [],
      minHumi: [],
      maxHumi: [],
      stats: [],
    };
  },
  watch: {
    devicestats: {
      handler: function() {
        this.labels = [];
        this.labels1 = [];
        this.temp = [];
        this.maxTemp = [];
        this.minTemp = [];
        this.humidity = [];
        this.minHumi = [];
        this.maxHumi = [];
        // console.log(this.stats, "stats");
        // console.log(this.stats, "tempchart");
        let lengtharray = [];
        this.stats = this.devicestats;
        for (const element of this.stats) {
          lengtharray.push(element.stats.length);
        }
        let length = Math.max(...lengtharray);
        let index = lengtharray.indexOf(length);
        // console.log(length, index);
        let clone = this.stats[index];
        this.stats[index] = this.stats[0];
        this.stats[0] = clone;
        //   console.log(this.stats, "stats");
        this.stats = this.stats.filter((stat) => stat.stats.length != 0);
        // console.log(this.stats, "final stats");
        for (let j = 0; j < this.stats.length; j++) {
          this.temp[j] = [];
          this.humidity[j] = [];
          let k = 0;
          let statlength = this.stats[j].stats.length;
          //   console.log(statlength, j, "length");
          for (let i = 0; i < length; i++) {
            if (this.recordtype === "default") {
              if (j == 0) {
                let date = this.stats[j].stats[i].createdAt;
                const fulldate2 = moment(date, "x", true).format(
                  "DD/MM/YY | HH:mm"
                );
                this.labels1.push({
                  label: fulldate2,
                });
                this.temp[j].push({
                  value: this.stats[j].stats[i].temperature,
                });
                this.humidity[j].push({
                  value: this.stats[j].stats[i].humidity,
                });
              } else {
                let createdAt1 = this.stats[0].stats[i].createdAt;
                createdAt1 = moment(createdAt1, "x", true).format(
                  "DD/MM/YY | HH:mm"
                );
                let createdAt2 = this.stats[j].stats[k].createdAt;
                createdAt2 = moment(createdAt2, "x", true).format(
                  "DD/MM/YY | HH:mm"
                );
                let range = moment(createdAt1, "DD/MM/YY | HH:mm").diff(
                  moment(createdAt2, "DD/MM/YY | HH:mm")
                );
                range = range / 1000;
                if (range <= 360 && range >= -360) {
                  this.temp[j].push({
                    value: this.stats[j].stats[k].temperature,
                  });
                  this.humidity[j].push({
                    value: this.stats[j].stats[k].humidity,
                  });
                  k++;
                } else if (range > 360) {
                  if (k > 0) {
                    i--;
                    k++;
                  }
                } else {
                  if (k > 0) {
                    this.temp[j].push({
                      value: this.stats[j].stats[k - 1].temperature,
                    });
                    this.humidity[j].push({
                      value: this.stats[j].stats[k - 1].humidity,
                    });
                  } else {
                    this.temp[j].push({
                      value: null,
                    });
                    this.humidity[j].push({
                      value: null,
                    });
                  }
                }
                if (k == statlength) {
                  break;
                }
              }
            } else if (this.recordtype === "hourly") {
              if (j == 0) {
                let year = this.stats[j].stats[i]._id.year;
                let month = this.stats[j].stats[i]._id.month;
                let day = this.stats[j].stats[i]._id.day;
                let hour = this.stats[j].stats[i]._id.hour;
                let fulldate = `${year}-${month}-${day} ${hour}`;
                const fulldate2 = moment(fulldate, "YYYY-M-D H", true).format(
                  "DD/MM/YY | HH:mm"
                );
                this.labels1.push({
                  label: fulldate2,
                });
                this.temp[j].push({
                  value: this.stats[j].stats[i].temperature,
                });
                this.humidity[j].push({
                  value: this.stats[j].stats[i].humidity,
                });
              } else {
                let year = this.stats[0].stats[i]._id.year;
                let month = this.stats[0].stats[i]._id.month;
                let day = this.stats[0].stats[i]._id.day;
                let hour = this.stats[0].stats[i]._id.hour;
                let fulldate = `${year}-${month}-${day} ${hour}`;
                let createdAt1 = moment(fulldate, "YYYY-M-D H", true).format(
                  "DD/MM/YY | HH a"
                );
                let year2 = this.stats[j].stats[k]._id.year;
                let month2 = this.stats[j].stats[k]._id.month;
                let day2 = this.stats[j].stats[k]._id.day;
                let hour2 = this.stats[j].stats[k]._id.hour;
                let fulldate2 = `${year2}-${month2}-${day2} ${hour2}`;
                let createdAt2 = moment(fulldate2, "YYYY-M-D H", true).format(
                  "DD/MM/YY | HH a"
                );
                let range = moment(createdAt1, "DD/MM/YY | HH a").diff(
                  moment(createdAt2, "DD/MM/YY | HH a")
                );
                if (range == 0) {
                  this.temp[j].push({
                    value: this.stats[j].stats[k].temperature,
                  });
                  this.humidity[j].push({
                    value: this.stats[j].stats[k].humidity,
                  });
                  k++;
                } else if (range > 0) {
                  if (k > 0) {
                    i--;
                    k++;
                  }
                } else {
                  if (k > 0) {
                    this.temp[j].push({
                      value: this.stats[j].stats[k - 1].temperature,
                    });
                    this.humidity[j].push({
                      value: this.stats[j].stats[k - 1].humidity,
                    });
                  } else {
                    this.temp[j].push({
                      value: null,
                    });
                    this.humidity[j].push({
                      value: null,
                    });
                  }
                }
                if (k == statlength) {
                  break;
                }
              }
            } else if (this.recordtype === "daily") {
              if (j == 0) {
                let year = this.stats[j].stats[i]._id.year;
                let month = this.stats[j].stats[i]._id.month;
                let day = this.stats[j].stats[i]._id.day;
                let fulldate = `${year}-${month}-${day}`;
                const fulldate2 = moment(fulldate, "YYYY-M-D", true).format(
                  "DD/MM/YY"
                );
                this.labels1.push({
                  label: fulldate2,
                });
                this.temp[j].push({
                  value: this.stats[j].stats[i].temperature,
                });
                this.humidity[j].push({
                  value: this.stats[j].stats[i].humidity,
                });
              } else {
                let year = this.stats[0].stats[i]._id.year;
                let month = this.stats[0].stats[i]._id.month;
                let day = this.stats[0].stats[i]._id.day;
                let fulldate = `${year}-${month}-${day}`;
                let createdAt1 = moment(fulldate, "YYYY-M-D", true).format(
                  "DD/MM/YY"
                );
                let year2 = this.stats[j].stats[k]._id.year;
                let month2 = this.stats[j].stats[k]._id.month;
                let day2 = this.stats[j].stats[k]._id.day;
                let fulldate2 = `${year2}-${month2}-${day2}`;
                let createdAt2 = moment(fulldate2, "YYYY-M-D", true).format(
                  "DD/MM/YY"
                );
                let range = moment(createdAt1, "DD/MM/YY").diff(
                  moment(createdAt2, "DD/MM/YY")
                );
                if (range == 0) {
                  this.temp[j].push({
                    value: this.stats[j].stats[k].temperature,
                  });
                  this.humidity[j].push({
                    value: this.stats[j].stats[k].humidity,
                  });
                  k++;
                } else if (range > 0) {
                  if (k > 0) {
                    i--;
                    k++;
                  }
                } else {
                  if (k > 0) {
                    this.temp[j].push({
                      value: this.stats[j].stats[k - 1].temperature,
                    });
                    this.humidity[j].push({
                      value: this.stats[j].stats[k - 1].humidity,
                    });
                  } else {
                    this.temp[j].push({
                      value: null,
                    });
                    this.humidity[j].push({
                      value: null,
                    });
                  }
                }
                if (k == statlength) {
                  console.log(k, "k is equal to length");
                  break;
                }
              }
            } else if (this.recordtype === "monthly") {
              if (j == 0) {
                let year = this.stats[j].stats[i]._id.year;
                let month = this.stats[j].stats[i]._id.month;
                let fulldate = `${year}-${month}`;
                const fulldate2 = moment(fulldate, "YYYY-M", true).format(
                  "MM/YY"
                );
                this.labels1.push({
                  label: fulldate2,
                });
                this.temp[j].push({
                  value: this.stats[j].stats[i].temperature,
                });
                this.humidity[j].push({
                  value: this.stats[j].stats[i].humidity,
                });
              } else {
                let year = this.stats[0].stats[i]._id.year;
                let month = this.stats[0].stats[i]._id.month;
                let fulldate = `${year}-${month}`;
                let createdAt1 = moment(fulldate, "YYYY-M", true).format(
                  "MM/YY"
                );
                let year2 = this.stats[j].stats[k]._id.year;
                let month2 = this.stats[j].stats[k]._id.month;
                let fulldate2 = `${year2}-${month2}`;
                let createdAt2 = moment(fulldate2, "YYYY-M", true).format(
                  "MM/YY"
                );
                let range = moment(createdAt1, "MM/YY").diff(
                  moment(createdAt2, "MM/YY")
                );
                if (range == 0) {
                  this.temp[j].push({
                    value: this.stats[j].stats[k].temperature,
                  });
                  this.humidity[j].push({
                    value: this.stats[j].stats[k].humidity,
                  });
                  k++;

                  console.log(i, k, "k");
                } else if (range > 0) {
                  if (k > 0) {
                    i--;
                    k++;
                  }
                } else {
                  if (k > 0) {
                    this.temp[j].push({
                      value: this.stats[j].stats[k - 1].temperature,
                    });
                    this.humidity[j].push({
                      value: this.stats[j].stats[k - 1].humidity,
                    });
                  } else {
                    this.temp[j].push({
                      value: null,
                    });
                    this.humidity[j].push({
                      value: null,
                    });
                  }
                }
                if (k == statlength) {
                  break;
                }
              }
            } else if (this.recordtype === "yearly") {
              if (j == 0) {
                let year = this.stats[j].stats[i]._id.year;
                let fulldate = `${year}`;
                const fulldate2 = moment(fulldate, "YYYY", true).format("YYYY");
                this.labels1.push({
                  label: fulldate2,
                });
                this.temp[j].push({
                  value: this.stats[j].stats[i].temperature,
                });
                this.humidity[j].push({
                  value: this.stats[j].stats[i].humidity,
                });
              } else {
                let year = this.stats[0].stats[i]._id.year;
                let createdAt1 = moment(year, "YYYY-M-D H", true).format(
                  "YYYY"
                );
                let year2 = this.stats[j].stats[k]._id.year;
                let createdAt2 = moment(year2, "YYYY", true).format("YYYY");
                let range = moment(createdAt1, "YYYY").diff(
                  moment(createdAt2, "YYYY")
                );
                if (range == 0) {
                  this.temp[j].push({
                    value: this.stats[j].stats[k].temperature,
                  });
                  this.humidity[j].push({
                    value: this.stats[j].stats[k].humidity,
                  });
                  k++;
                } else if (range > 0) {
                  if (k > 0) {
                    i--;
                    k++;
                  }
                } else {
                  if (k > 0) {
                    this.temp[j].push({
                      value: this.stats[j].stats[k - 1].temperature,
                    });
                    this.humidity[j].push({
                      value: this.stats[j].stats[k - 1].humidity,
                    });
                  } else {
                    this.temp[j].push({
                      value: null,
                    });
                    this.humidity[j].push({
                      value: null,
                    });
                  }
                }
                if (k == statlength) {
                  break;
                }
              }
            }
          }
        }
        for (let j = 0; j < this.stats.length; j++) {
          this.labels[j] = this.labels1;
        }
        let labels2 = [];
        let temp2 = [];
        let humi2 = [];
        for (let i = 0; i < this.stats.length; i++) {
          labels2.push({
            category: this.labels[i],
          });
          temp2.push({
            seriesName: this.stats[i].device?.settings?.name,
            data: this.temp[i],
          });
          humi2.push({
            seriesName: this.stats[i].device?.settings?.name,
            data: this.humidity[i],
          });
        }

        if (this.labels.length > 0) {
          this.dataSourceTemp = {
            chart: {
              caption: this.$t("caption-temp"),
              subcaption: this.$t("sub_cap"),
              yaxisname: this.$t("temp"),
              numbersuffix: "°C",
              xaxisname: this.$t("time"),
              lineThickness: "3",
              theme: "fusion",
              paletteColors: "#213e7a,#DC3030,#F3C963",
              exportEnabled: "1",
              exportFileName: this.title,
              logoURL: "../assets/images/logo.png",
              logoScale: "18",
              logoPosition: "TL",
            },
            categories: labels2,
            dataset: temp2,
          };
          this.dataSourceHumi = {
            chart: {
              caption: this.$t("caption-humid"),
              subcaption: this.$t("sub_cap"),
              yaxisname: this.$t("humid"),
              numbersuffix: "%",
              xaxisname: this.$t("time"),
              lineThickness: "3",
              theme: "fusion",
              paletteColors: "#213e7a,#DC3030,#F3C963",
              exportEnabled: "1",
              exportFileName: this.title,
            },
            categories: labels2,
            dataset: humi2,
          };
        } else {
          this.dataSourceTemp = this.dataSourceHumi = "";
        }
      },

      deep: true,
    },
  },
  // methods: {
  //   showGraph(type) {
  //     this.$emit("show-graph", type);
  //   },
  //   getdevicestats(type) {
  //     //   console.log(type, "record type");
  //     this.$emit("fetchgroupdevicestats", type);
  //   },
  // },
};
</script>

<style scoped></style>
